export default __webpack_public_path__ + "static/media/icon-concluido-green.100c2df3.svg";